import { render, staticRenderFns } from "./package-order.vue?vue&type=template&id=7cf281fe&scoped=true&"
import script from "./package-order.vue?vue&type=script&lang=js&"
export * from "./package-order.vue?vue&type=script&lang=js&"
import style0 from "./package-order.vue?vue&type=style&index=0&id=7cf281fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf281fe",
  null
  
)

export default component.exports